import * as React from 'react';
import NameBasedMenuItem, {
  NameBasedMenuItemWithIdReturn
} from "../../../../../Document/components/panelSegments/components/NameBasedMenuItem";
import {GuidBasedMenuItem} from "../../../../../Document/components/panelSegments/components";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {AccordionCard} from "../../../../../Document/components";
import {Modal} from "@mui/material";
import {useState} from "react";
import MaterialTable from "@material-table/core";
import {EmptyList} from "../../../../../../components/EmptyList";
import LoadingSpinner from "../../../../../../components/Spinner/loading.spinner";

const ESignUpload = props => {
  const {
    classes,
    showModal,
    setShowModal,
    initialCompanies,
    initialCategories,
    initialSections,
    initialClassifications,
    statusSelect,
    sectionSelect,
    categorySelect,
    companySelect,
    classificationSelect,
    onHandleClassificationSelect,
    onHandleCategorySelect,
    onHandleSectionSelect,
    onHandleCompanySelect,
    handleCloseModal,
    onUploadFiles,
    pageTitle,
    selectedDocuments,
    renderButton,
    buttonText,
    buttonIcon,
    onButtonClick,
    customButtons = [],
    view
  } = props;

  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState('sm');
  const [expanded, setExpanded] = useState(true);

  let options= {
    idSynonym: "id",
    emptyRowsWhenPaging: false,
    pageSize: selectedDocuments.length > 10 ? 20 : (selectedDocuments.length > 5 ? 10 : 5),
    search: false,
    selection:  false,
    rowStyle: {
      height: '5px'
    }
  }

  let columns = [
    {
      title: 'File Name',
      field: 'original_filename',
      cellStyle: {
        width: '30%',
        maxWidth: '30%'
      }
    },
    {
      title: 'Page Count',
      field: 'page_count'
    }
  ];

  return (
    <Modal
      onClose={handleCloseModal}
      open={showModal}
      className={classes.modalContent}
    >
      <div className={classes.root}>
        {/*<Card className={classes.content}>    */}
        <AccordionCard
          classes={classes}
          summaryText="ESign Upload Documents"
          expanded={expanded}
          setExpanded={setExpanded}

          initialSections={initialSections}
          initialCompanies={initialCompanies}
          initialCategories={initialCategories}
          initialClassifications={initialClassifications}

          statusSelect={statusSelect}
          sectionSelect={sectionSelect}
          companySelect={companySelect}
          categorySelect={categorySelect}
          classificationSelect={classificationSelect}

          onHandleSectionSelect={onHandleSectionSelect}
          onHandleCompanySelect={onHandleCompanySelect}
          onHandleCategorySelect={onHandleCategorySelect}
          onHandleClassificationSelect={onHandleClassificationSelect}

          handleCloseModal={handleCloseModal}
          pageTitle={'ESign Upload Details - ' + statusSelect.toUpperCase() +  ' Documents'}

          renderStatus={false}
          renderFileName={false}
          renderCompany={false}
          renderAttributes={false}
          renderEndDate={false}
          renderBeginDate={false}

          buttonText="Upload"
          buttonIcon={FileUploadIcon}
          onButtonClick={onUploadFiles}
        />
        {!selectedDocuments ? (<LoadingSpinner/>) : (
          <MaterialTable
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <EmptyList
                    label="No eSign Documents to Upload!"
                  />
                ),
              },
            }}
            title=""
            options={options}
            exportbutton={false}
            columns={columns}
            data={selectedDocuments}
          />
        )}
        {/*</Card>*/}

      </div>
    </Modal>
  );
}

export default ESignUpload;
